import React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  header: string
  children: React.ReactNode
}

export const FormSection = ({ header, children }: Props) => {
  return (
    <Box
      background="grey200"
      borderRadius={{
        all: 'abs008',
      }}
      padding="s24"
      gap="s16"
    >
      <Text.Header3>{header}</Text.Header3>
      {children}
    </Box>
  )
}
